<template>
    <div class="relative w-full">
        <div class="mb-4 text-center">
            <h3 class="font-black">Message Preview</h3>
        </div>
        <div class="message-preview-wrapper">
            <div class="message-preview-wrapper-inner" ref="messagePreviewWrapperInner">
                <div class="message-preview">
                    <img
                        v-if="media"
                        :src="media"
                        class="block w-full rounded-lg mb-3"
                        alt="preview of image attachment"
                    >
                    <div
                        v-if="messagePreview"
                        class="p-3 text-white bg-blue-500 rounded-lg"
                        v-html="messagePreview"
                    ></div>
                    <div
                        v-else
                        class="p-3 text-gray-700 bg-gray-100 rounded"
                    >Enter a message to show preview...</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            message: {
                type: String,
                default: '',
            },
            media: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                first_name: 'John',
                last_name: 'Doe',
            };
        },
        computed: {
            messagePreview() {
                const pattern = /{\s*([a-zA-Z]+)(\s+(default)\=[\'\"]([^\'\"\n]*)[\'\"])?\s*}/g;
                const linkPattern = /\{\s?link url="([^"]*)"(?:\s?track)?\s?\}/g;
                const fieldsMap = {
                    'firstName': 'first_name',
                    'lastName': 'last_name',
                };
                const matches = [...this.message.matchAll(new RegExp(pattern))];
                const linkMatches = [...this.message.matchAll(new RegExp(linkPattern))];

                var newMessage = this.message.replace(/\n/g, '<br />');

                matches.forEach(match => {
                    const fieldKey = fieldsMap.hasOwnProperty(match[1]) ?
                        fieldsMap[match[1]] : null;
                    const defaultValue = match[4];

                    const fieldValue = (
                      fieldKey &&
                      this[fieldKey] &&
                      this[fieldKey].length > 0
                    ) ? this[fieldKey] : null;

                    const replaceWith = fieldValue ?
                        fieldValue :
                        defaultValue ? defaultValue : null;

                    const helpText = 'This is a variable. It will be replaced with the corresponding field for each contact. If the field is not available, it will look for a default value. If no default is found, the variable will be omitted.';

                    const variableHtml = replaceWith ?
                        `<span class="message-preview-variable" title="${helpText}">${replaceWith}</span>` :
                        '';

                    newMessage = newMessage.replace(match[0], variableHtml);
                });
                // Swap out link tags in the message with a preview of what the shortened link will actually look like
                  linkMatches.forEach(match => {
                      const replaceWith = "txts.pt/XXXXXXX";
                      const helpText = 'This is a link placeholder. It will be replaced with a shortened link that will redirect recipients to the original link you entered.';
                      const variableHtml = replaceWith ?
                          `<span class="message-preview-variable" title="${helpText}">${replaceWith}</span>` :
                          '';

                      newMessage = newMessage.replace(match[0], variableHtml);
                  });

                // Add trial watermark if organization is on trial and there's actual message content
                if (this.$page.props.active_trial && this.message && this.message.trim()) {
                    newMessage += '<br /><br />Sent via TextSpot Trial';
                }

                return newMessage;
            }
        },
        methods: {
            scrollToBottom () {
                if (this.$refs.messagePreviewWrapperInner) {
                    this.$refs.messagePreviewWrapperInner.scrollTo({
                        top: this.$refs.messagePreviewWrapperInner.scrollHeight,
                        behavior: 'smooth',
                    })
                }
            },
        },
        watch: {
            message() {
                this.scrollToBottom();
            }
        }
    }
</script>
<style>
    .message-preview-wrapper {
        @apply mx-auto px-9 pb-4 relative bg-no-repeat bg-top max-w-xs;
        padding-top: 70px;
        background-image: url('/images/iphone-wrapper-cropped.png');
        background-size: 100%;
        height: 90%;
    }

    .message-preview-wrapper-inner {
        @apply h-full relative pt-3 pb-5 rounded-lg overflow-auto;
        min-height: 204px;
        max-height: 400px;
    }

    .message-preview-wrapper:before {
        @apply absolute inset-x-8 top-16 h-6 z-10;
        content: '';
        background: linear-gradient(180deg, white, transparent);
    }

    .message-preview-wrapper:after {
        @apply absolute inset-x-0 bottom-0 h-12 z-10;
        content: '';
        background: linear-gradient(0deg, white, transparent);
    }

    .message-preview {
        @apply flex flex-col items-start justify-end;
        min-height: 180px;
    }

    @media (min-width: theme('screens.lg')) {
        .message-preview-wrapper-inner {
            min-height: 284px;
        }

        .message-preview {
            min-height: 240px;
        }
    }

    .message-preview-variable {
        @apply bg-blue-700 shadow leading-loose px-2 py-1 font-black;
        cursor: help;
    }
</style>
